import { render, staticRenderFns } from "./create-task-official.vue?vue&type=template&id=5ff018fa&scoped=true"
import script from "./create-task-official.vue?vue&type=script&lang=js"
export * from "./create-task-official.vue?vue&type=script&lang=js"
import style0 from "./create-task-official.vue?vue&type=style&index=0&id=5ff018fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff018fa",
  null
  
)

export default component.exports